export default __webpack_public_path__ + "static/media/content-library.e4a43072.svg";